import script from "./PaymentMethodEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethodEmail.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentMethodEmail.vue?vue&type=style&index=0&id=a1519c2a&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1519c2a"]])

export default __exports__